<template>
  <div class="row" style="padding-top:20px;">
  <div class="col s12">

    <el-form ref="form" :model="$teras.page" v-on:submit.prevent="onSubmit" :rules="rules" label-width="204px">

        <el-form-item label="Nome" prop="file">
          <el-input  v-model="$teras.page.file"></el-input>
        </el-form-item>


        <el-form-item label="Titolo" prop="titolo">
            <el-input  v-model="$teras.page.titolo"></el-input>
        </el-form-item>


      <el-form-item label="Contenuto">
          <tinymce v-model="$teras.page.testo" :initvalue="$teras.page.testo" height="240" language="ita" > </tinymce>
      </el-form-item>

      <el-form-item :glutter="0">
        <el-col :span="11">
          <el-button style="width:100%;" @click="onCancel">Cancel</el-button>
        </el-col>
        
        <el-col :span="11" :offset="2">
          <el-button type="primary" @click="onSubmit" style="width:100%;">Salva</el-button>
        </el-col>
      </el-form-item>

    </el-form>


</div>
  </div>
</template>

<script>
import tinymce from './Page-tinymce.vue'


export default {
  name: 'ads-edit',
  components: {
    tinymce
  },
  data() {
    return {
      rules: {
        file: [
          { required: true, message: 'Il nome del file è obbligatorio', trigger: 'blur' }
        ],
        titolo: [
          { required: true, message: 'Il titolo della pagina è obbligatorio', trigger: 'blur' }
        ]       
      }
    }
  },
  created () {
    console.log("Arrivo al page-edit.vue")
    this.$teras.pageTitle = (this.$teras.page.file=='') ? 'Nuova Pagina' : 'Modifica Pagina: '+this.$teras.page.titolo
  },
  beforeDestroy () {
    clearInterval(this.minInterval)
  },
  methods: {
    onCancel() {
        this.$router.go(-1)
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          //console.log("CANCELLAZIONE "+this.form.cancellazione)
          this.Save()
        } else {
          return false;
        }
      });
    },
    Save(){
      var parent = this;
      this.$axios.pageSave(this.$teras.page,'/www/www.euromedlab2019barcelona.org/2019/page/').then(function (data) {
        parent.$router.push('/loadpage/saved/'+data.page.file);
      })
    }

  }
}
</script>
<style>
.el-checkbox {
    width: 100%;
    margin: 0 !important;
}.el-form-item__label{
  width: 16.66% !important;
}.col.m6 .el-form-item__label{
  width: 33.32% !important;

}.el-upload{
  display:block !important;
}.el-upload-dragger{
  height:100px !important;
  width:100% !important;
}
</style>
